export default {
  getErrorResponse(error) {
    if (error?.response?.data) {
      const statusCode = error.response.status || error.request?.status || 500;
      const d = error.response.data;
      const userAlreadyExists =
        d.errorDescription &&
        d.errorDescription === 'Este visualizador já existe'
          ? 409
          : statusCode;

      const defaultMessage =
        'Desculpe, não foi possível concluir a ação no momento. Você será redirecionado para a página principal. Por favor, tente novamente.';

      return {
        data: {},
        code: d.errorCode || 500,
        message: d.errorDescription ? d.errorDescription : defaultMessage,
        status: userAlreadyExists
      };
    }
    return {
      data: {},
      code: 500,
      message: 'Ocorreu um erro de conexão. Por favor, tente novamente.',
      status: 500
    };
  },

  getResponseError(error) {
    if (error?.response?.data) {
      const statusCode = error.request.status;
      const d = error?.response?.data;
      return {
        code: d.errorCode || statusCode,
        message: d.errorDescription
      };
    }
  }
};
